import React from "react";
import { Heading } from "@walmart-web/livingdesign-components";
import styles from "./layout.module.css";
import { useSelector } from "react-redux";
import SearchBox from "../components/searchbox/searchbox";
import { Disclaimer } from "../app";
import { RootState } from "../store/store";
import { SourceDocument } from "../types";
import Answer from "../components/answer/answer";
import Feedback from "../components/feedback/feedback";
// import RaiseTicket from "../components/raiseticket/raiseticket";
import RecommendedQuestions from "../components/recommendedquestions/recommendedquestions";
import { CANOPUS_DOCUMENT_MAP, URL_CANOPUS_DOCUMENT } from "../store/constants";

const Layout = () => {
  const fetchState = useSelector((state: RootState) => state.genAIResponse);
  const suggestedQuestions = fetchState?.response?.Alt_Questions;
  const question = useSelector((state: RootState) => state.currentQuestion);

  //Format source documents array to only contain top 2 Unique source documents with blank("") url field
  const formatDocs = (docs: SourceDocument[]) => {
    if (!docs) {
      return;
    }
    const final = docs.filter((doc: SourceDocument) => doc.url === "");
    const formattedDocs = final.map((doc: SourceDocument) => {
      const docType = doc.document.split("/").pop() || "";
      const tempObj = { ...doc, name: docType };
      const docMap = CANOPUS_DOCUMENT_MAP.find((docMap) =>
        docType.includes(docMap.docType)
      );
      tempObj.docLink = `${URL_CANOPUS_DOCUMENT}/${docMap?.uuid}/1.0/content`;
      tempObj.fileid = docMap?.uuid
      return tempObj;
    });
    const uniqueSource = [
      ...new Map(formattedDocs.map((doc) => [doc["name"], doc])).values(),
    ];
    if (uniqueSource.length === 0) {
      return;
    }
    return uniqueSource.slice(0, 2);
  };
  return (
    <div className={styles.mainLayout}>
      <div>
        <SearchBox />
      </div>
      <div className={styles.qnaLayout}>
        <div className={styles.ansSection}>
          <div className={styles.answerHeading}>
            <Heading>e-WMMS Gen AI Assistant:</Heading>
          </div>
          <div className={styles.contentSection}>
            <Answer
              filteredData={fetchState?.response}
              sources={formatDocs(fetchState?.source_documents)}
            />
            {question && (
              <div className={styles.feedbackSection}>
                <Feedback />
              </div>
            )}
          </div>
        </div>
        {suggestedQuestions && (
          <div className={styles.recommendationsLayout}>
            <RecommendedQuestions suggestedQuestions={suggestedQuestions} />
            {/* <RaiseTicket /> */}
          </div>
        )}
      </div>
      <Disclaimer />
    </div>
  );
};

export default Layout;
